import Api from "./api";

export default class ReadingsApi extends Api {
	constructor(token, clientId, onUnathourized) {
		super(token, clientId, onUnathourized);
		this.baseUrl = this.getBaseUrl() + "readings/";
	}

	getLatestReadings(facility, onSuccess, onError) {
		let endPoint =
			this.baseUrl + `latest/?facility=${facility.split("/").slice(-2)[0]}`;
		this.Get(endPoint, onSuccess, onError);
	}

    getAllTrends(
        facility,
        fromDate,
        toDate,
        onSuccess,
        onError,
        aggType,
        keys,
        locations,
        systems
    ) {

        const endPoint = this.baseUrl + "all_trends/";

        let data = {
            facility: facility? facility.split("/").slice(-2)[0] : undefined,
            from_date: fromDate.toISOString().split("T")[0],
            to_date: toDate.toISOString().split("T")[0],
            time_agg: aggType,
            keys: keys,
        };

        if (locations.length > 0)
            data["location"] = locations
        if (systems.length > 0)
            data["system"] = systems

        this.Post(endPoint, data, onSuccess, onError);
    }

	getTrendsExcel(facility, fromDate, toDate, aggType, onSuccess, onError) {
		let endPoint =
			this.baseUrl +
			`trends_excel?facility=${facility.split("/").slice(-2)[0]}&from_date=${fromDate.toISOString().split("T")[0]}&to_date=${toDate.toISOString().split("T")[0]}`;

		if (aggType) {
			endPoint = endPoint + `&time_agg=${aggType}`;
		}
		
		fetch(
            endPoint,
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.getToken()
                }
            }
        ).then(
            (response) => {

                if (!response.ok) {
                    if (response.status === 401)
                        this.onUnauthorized()
                    throw response
                }
                return response.blob()
            }
        ).then(
            (blob) => {
                onSuccess(blob)
            }
        ).catch(
            () => onError()
        )
	}

	getTrendFilters(facility, onSuccess, onError) {
		let endPoint =
			this.baseUrl +
			`trend_filters/?facility=${facility.split("/").slice(-2)[0]}`;
		this.Get(endPoint, onSuccess, onError);
	}


	getEnergyData(
		fromDate,
		toDate,
		onSuccess,
		onError,
		timeAgg,
		dataAgg,
		facility,
		energyType
	) {
		
		const endPoint = this.baseUrl + "energy_data/";

		let data = {
			from_date: fromDate.toISOString().split("T")[0],
			to_date: toDate.toISOString().split("T")[0],
			time_agg: timeAgg,
			data_agg: dataAgg,
			energy_type: energyType
		};

		if (facility)
			data["facility"] = facility.split("/").slice(-2)[0]

		this.Post(endPoint, data, onSuccess, onError);
	}
}
